<template>
	<div>
		<Header></Header>
		<searchShop :mch="mch"></searchShop>
		<!-- 广告 -->
		<div class="adv" v-if="false"></div>
		<navShop :mch="mch"></navShop>
		<!-- 轮播 -->
		<template v-for="(item, index) in template">
			<div class="swiper-container banner-swiper" v-if="item.type == 'banner'">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(value,key) in item.param.banner_list" :key="key">
						<img :src="value.pic_url" alt />
					</div>
					<div class="swiper-button-prev banner-l"></div>
					<div class="swiper-button-next banner-r"></div>
				</div>
				<div class="swiper-pagination banner-dot"></div>
			</div>
		</template>
		<!-- 楼层 -->
		<div class="w">
			<div class="floor-title d-flex justify-content-center">优选商品</div>
			<div class="floor-list clearfloat d-flex flex-wrap">
				<template v-for="(item,index) in list">
					<div class="ttshop_collectionlist" @click="toGoods(item.id)">
						<div class="ttshop_collectionimg">
							<img :src="item.pic_url || item.cover_pic" alt class="ttshop_collecimg" />
							<div class="ttshop_gmqx clearfloat" v-if="false">
								<button class="ttshop_join">
									<i>
										<img src="../../assets/images/ttshop_addshop.png" alt />
									</i>
									加入购物车
								</button>
								<button class="ttshop_removeshop">取消收藏</button>
							</div>
						</div>
						<div :class="['ttshop_collcon','ttshop_collcon'+index]" :style="{padding: item.pic_list.length<=6 ? '0 0': '0 18px'}">
							<div class="ttshop_collconter swiper-container">
								<ul class="clearfloat swiper-wrapper">
									<li class="swiper-slide" v-for="(itemSwiper,indexSwiper) in item.pic_list" :key="itemSwiper" @mouseenter="picEnter(itemSwiper,index)">
										<img :src="itemSwiper" alt />
									</li>
								</ul>
							</div>
							<!-- 左右箭头 -->
							<div class="swiper-button-prev ttshop_prev" @click.stop v-if="item.pic_list.length>6"></div>
							<div class="swiper-button-next ttshop_next" @click.stop v-if="item.pic_list.length>6"></div>
						</div>
						<div class="ttshop_collbut">
							<h5 v-text="'￥'+item.price"></h5>
							<p class="ttshop_shopname" v-text="item.name"></p>
							<div class="ttshop_colltext clearfloat">
								<div class="ttshop_colltextleft">
									<p><span v-text="item.comment_count > 0 ? item.comment_count : 0"></span>评价</p>
								</div>
								<div class="ttshop_colltextright" v-if="item.comment_count > 0">
									<p><span v-text="item.good_rate+'%'"></span>好评</p>
								</div>
							</div>
							<div class="clearfloat ttshop_collbutton" v-if="item.service && item.service.length">
								<p v-for="(itemService,indexService) in item.service" :key="indexService" v-text="itemService"></p>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
		<!-- 大广告 -->
		<div class="adv-big" v-if="false">
			<img src="../../assets/images/banner_8.jpg" alt />
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import searchShop from "@/components/search/searchShop";
	import navShop from "@/components/nav/navShop";
	import sidebar from "@/components/sidebar/sidebar";
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	export default {
		components: {
			Header,
			Foot,
			searchShop,
			navShop,
		},
		data() {
			return {
				mch_id: this.$route.query.mch_id,
				mch: {}, //店铺信息
				template: [],
				list: [], //商品
			};
		},
		created() {
			this.getData();
			this.geyCatGoodsList();
		},
		methods: {
			getData() {
				let params = {
					mch_id: this.mch_id
				};
				this.$api
					.shopIndex(params)
					.then((res) => {
						if (res.code == 0) {
							this.mch = res.data.mch_info;
							this.template = res.data.template;
							this.swiperList();
						}
					})
					.catch((err) => {
						this.common.message(this, err);
					});
			},
			// 获取数据
			geyCatGoodsList() {
				this.$loading();
				this.data_type = false;
				let params = {
					mch_id: this.mch_id
				};
				this.$api
					.catGoodsList(params)
					.then((res) => {
						if (res.code == 0) {
							this.$loading().close();
							this.list = res.data.list;
							setTimeout(() => {
								// 商品轮播
								for (let i = 0; i < res.data.list.length; i++) {
									let element = ".ttshop_collcon" + i + " .ttshop_collconter";
									let nextEl = ".ttshop_collcon" + i + " .ttshop_next";
									let prevEl = ".ttshop_collcon" + i + " .ttshop_prev";
									let mySwiper = new Swiper(element, {
										loop: false,
										slidesPerView: 5,
										spaceBetween: 6,
										observer: true,
										observeParents: true,
										navigation: {
											nextEl: nextEl,
											prevEl: prevEl,
										},
									});
								}
							}, 500)
						}
					})
					.catch((err) => {
						let that = this;
						this.common.message(this, err,function(){
							setTimeout(()=>{
								that.$router.go(-1);
							},1000)
						});
					});
			},
			// 进入商品详情
			toGoods(id) {
				let url = this.$router.resolve({
					path: "/pages/goods/goods",
					query: {
						id: id
					}
				})
				window.open(url.href);
			},
			// 移入图片
			picEnter(url, index) {
				if (url) {
					this.list[index].pic_url = url;
				}
			},
			swiperList() {
				setTimeout(()=>{
					new Swiper(".banner-swiper", {
						autoplay: true,
						loop: true, // 循环模式选项
						pagination: {
							el: ".swiper-pagination",
							clickable: true,
						},
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
						effect: "fade",
						fade: {
							crossFade: false,
						},
					});
				},100)
			}
		},
	};
</script>

<style lang="scss">
	// 广告
	.adv {
		height: 120px;
		background: #cccccc;
	}

	// 大广告
	.adv-big {
		height: 500px;
		background: #cccccc;
	}

	// 轮播
	.banner-swiper {
		height: 460px;

		.swiper-button-prev,
		.swiper-container-rtl .swiper-button-next {
			background-image: url(../../assets/images/shop_l.png);
			background-size: 40px;
			left: 20px;
			height: 40px;
			width: 40px;
		}

		.swiper-button-next,
		.swiper-container-rtl .swiper-button-prev {
			background-image: url(../../assets/images/shop_r.png);
			background-size: 40px;
			right: 20px;
			height: 40px;
			width: 40px;
		}

		.banner-dot {
			.swiper-pagination-bullet {
				height: 10px !important;
				width: 10px !important;
				background: #ffffff;
				opacity: 0.6;
			}

			.swiper-pagination-bullet-active {
				background: #ffffff;
				opacity: 1;
			}
		}
	}

	// 楼层
	.floor-title {
		height: 140px;
		font-size: 28px;
		padding-top: 60px;
		box-sizing: border-box;
	}

	.floor-list {
		.ttshop_collectionlist {
			cursor: pointer;
			float: left;
			width: 238px;
			background: #fff;
			padding: 12px;
			box-sizing: border-box;
			margin-bottom: 20px;

			.ttshop_collectionimg {
				width: 100%;
				height: 214px;
				margin-bottom: 10px;
				position: relative;
				overflow: hidden;

				.ttshop_collecimg {
					display: block;
					width: 100%;
					height: 100%;
					object-fit: cover;
					margin: 0 auto;
				}

				.ttshop_gmqx {
					width: 100%;
					height: 28px;
					background: #ff0e25;
					position: absolute;
					bottom: 0;
					left: -100%;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;

					.ttshop_join {
						float: left;
						width: 138px;
						height: 28px;
						border: 0;
						outline: none;
						font-size: 12px;
						color: #fff;
						background: #ff0e25;
						cursor: pointer;

						i {
							display: inline-block;
							width: 16px;
							height: 16px;
							vertical-align: -3px;

							img {
								display: block;
								width: 100%;
							}
						}
					}

					.ttshop_removeshop {
						width: 75px;
						height: 26px;
						margin-top: 1px;
						margin-right: 1px;
						font-size: 12px;
						color: #ff0e25;
						border: 0;
						outline: none;
						cursor: pointer;
						background: #fff;
					}
				}

				&:hover .ttshop_gmqx {
					left: 0;
				}
			}

			.ttshop_collcon {
				width: 100%;
				padding: 0 21px;
				box-sizing: border-box;
				position: relative;
				margin-bottom: 12px;

				.ttshop_collconter {
					width: 100%;

					ul {
						li {
							float: left;
							width: 32px !important;
							height: 32px;
							border: 1px solid #ebebeb;
							padding: 1px;
							box-sizing: border-box;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;

							&:hover {
								border-color: #ff0e25;
							}

							img {
								display: block;
								width: 28px;
								height: 28px;
								margin: 0 auto;
								object-fit: cover;
							}
						}
					}
				}

				.ttshop_prev {
					width: 14px;
					height: 14px;
					margin-top: -7px;
					background: url(../../assets/images/ttshop_scleft.png) center no-repeat;
					left: 0;
					cursor: pointer;
					z-index: 100;
					outline: none;
				}

				.ttshop_next {
					width: 14px;
					height: 14px;
					margin-top: -7px;
					background: url(../../assets/images/ttshop_scright.png) center no-repeat;
					right: 0;
					cursor: pointer;
					z-index: 100;
					outline: none;
				}
			}

			.ttshop_collbut {
				width: 100%;

				h5 {
					font-size: 20px;
					color: #ff4300;
					font-weight: bold;
					line-height: 20px;
					margin-bottom: 7px;
				}

				.ttshop_shopname {
					width: 100%;
					font-size: 12px;
					color: #666;
					font-weight: 400;
					line-height: 18px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					max-height: 36px;
					height: 36px;
					margin-bottom: 8px;
				}

				.ttshop_colltext {
					width: 100%;
					margin-bottom: 12px;

					.ttshop_colltextleft {
						float: left;

						p {
							font-size: 12px;
							color: #999;
							line-height: 12px;

							span {
								font-size: 12px;
								color: #0e9cff;
								margin-right: 4px;
							}
						}
					}

					.ttshop_colltextright {
						float: right;

						p {
							font-size: 12px;
							color: #999;
							line-height: 12px;

							span {
								font-size: 12px;
								color: #ff9010;
							}
						}
					}
				}

				.ttshop_collbutton {
					width: 100%;

					p {
						float: left;
						font-size: 12px;
						color: #ff0e25;
						border: 1px solid #ff0e25;
						border-radius: 3px;
						font-weight: 400;
						line-height: 12px;
						padding: 2px 4px;
						box-sizing: border-box;
						margin: 0 4px 4px 0;
					}
				}
			}
		}
		.ttshop_collectionlist:hover {
			.ttshop_shopname {
				color: #ff0e25;
			}
		}
	}
</style>
